import { Pages } from '../enums';

class Route {
  current = $state<Pages>(Pages.Login);
  return = $state<Pages>(Pages.Login);
}

export const route = new Route();